import React from 'react';
import { DatePicker } from 'antd';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { t } from '../i18n';
import { useFilterLabelClassName, useFilterContainerClassName, useFilterInputContainerClassName } from '../utils/languageUtils';

/**
 * 日期范围选择器
 * @description 同delivery/components/DateRangeFilterItem，原组件位于delivery模块，现将组件抽离至components公用模块，便于复用
 *              原引用delivery模块的组件未迁移至公用模块，仍需引用delivery模块的组件
 *              新开发可使用该公用组件
 */
interface DateRangerPickerItemProps {
    label: string;
    value?: [string | null, string | null] | null;
    onChange?: (dates: [string | null, string | null] | null) => void;
    className?: string;
    spanClassName?: string;
}

const DateRangerPicker: React.FC<DateRangerPickerItemProps> = ({ label, value, onChange, className, spanClassName }) => {
    const containerClassName = useFilterContainerClassName(className);
    const labelClassName = useFilterLabelClassName(spanClassName);
    const inputContainerClassName = useFilterInputContainerClassName();
    
    // 将字符串转换为 Dayjs 对象以供 DatePicker 使用
    const dayjsValue = value ? [
        value[0] ? dayjs(value[0]) : null,
        value[1] ? dayjs(value[1]) : null
    ] as [Dayjs | null, Dayjs | null] : null;

    // 处理 DatePicker 的变更，将 Dayjs 转换为字符串
    const handleChange = (dates: [Dayjs | null, Dayjs | null] | null, dateStrings: [string, string]) => {
        if (onChange) {
            onChange(dates ? [dateStrings[0] || null, dateStrings[1] || null] : null);
        }
    };

    return (
        <div className={containerClassName}>
            <span className={labelClassName}>{label}</span>
            <div className={inputContainerClassName}>
                <DatePicker.RangePicker
                    value={dayjsValue}
                    onChange={handleChange}
                    className="w-full"
                    placeholder={[t('components.input.start'), t('components.input.end')]}
                    format="YYYY-MM-DD"
                    size="middle"
                />
            </div>
        </div>
    );
};

export default DateRangerPicker;
